import React from 'react';
import { TrendingDown, Shield, Clock, Award } from 'lucide-react';

export function Hero() {
  return (
    <div className="bg-gradient-to-br from-indigo-900 to-indigo-700 text-white py-8 md:py-12 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-3xl md:text-5xl font-bold mb-4 px-2">
            Insurance That Works for You
          </h1>
          <p className="text-base md:text-xl mb-6 text-indigo-100 px-2">
            Watch insurers compete in real-time to offer you the best rates. Simple, transparent, and fair.
          </p>
          
          <a
            href="#quote-form"
            className="inline-block px-6 py-3 bg-white text-indigo-700 rounded-full font-semibold shadow-lg hover:bg-indigo-50 transition-colors duration-200 mb-6"
          >
            Compare Offers Now
          </a>
          
          <div className="max-w-4xl mx-auto mt-4">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
              <div className="bg-indigo-800/30 backdrop-blur-sm rounded-lg p-4 transform hover:scale-105 transition-transform border border-white">
                <div className="flex flex-col items-center text-center">
                  <div className="bg-purple-600 p-2 rounded-full mb-2">
                    <TrendingDown className="h-6 w-6 text-white-200" />
                  </div>
                  <h3 className="text-sm font-semibold mb-1 text-indigo-100">Lower Prices</h3>
                  <p className="text-xs text-indigo-200">Save money through competitive bidding</p>
                </div>
              </div>
              <div className="bg-indigo-800/30 backdrop-blur-sm rounded-lg p-4 transform hover:scale-105 transition-transform border border-white">
                <div className="flex flex-col items-center text-center">
                  <div className="bg-blue-600 p-2 rounded-full mb-2">
                    <Shield className="h-6 w-6 text-white-200" />
                  </div>
                  <h3 className="text-sm font-semibold mb-1 text-indigo-100">Trusted Providers</h3>
                  <p className="text-xs text-indigo-200">Verified and regulated companies</p>
                </div>
              </div>
              <div className="bg-indigo-800/30 backdrop-blur-sm rounded-lg p-4 transform hover:scale-105 transition-transform border border-white">
                <div className="flex flex-col items-center text-center">
                  <div className="bg-green-400 p-2 rounded-full mb-2">
                    <Clock className="h-6 w-6 text-white-200" />
                  </div>
                  <h3 className="text-sm font-semibold mb-1 text-indigo-100">Real-Time Bidding</h3>
                  <p className="text-xs text-indigo-200">Watch offers improve in real-time</p>
                </div>
              </div>
              <div className="bg-indigo-800/30 backdrop-blur-sm rounded-lg p-4 transform hover:scale-105 transition-transform border border-white">
                <div className="flex flex-col items-center text-center">
                  <div className="bg-red-500 p-2 rounded-full mb-2">
                    <Award className="h-6 w-6 text-white-200" />
                  </div>
                  <h3 className="text-sm font-semibold mb-1 text-indigo-100">Live Notifications</h3>
                  <p className="text-xs text-indigo-200">Get notified every time a new bid is placed</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}